import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import Actions from "../Actions";
import Search from "../Search";
import Button from "../Button";
import Icon from "../Icon";
import Table, { Hidden } from "../Table";
import Label from "../Label";
import Overlay from "../Overlay";
import moment from "moment";
import Empty from "../Empty";
import CommonAreaAssetForm from "../../components/CommonAreaAssetForm";
import {
  clearCommonAreaAssetFormData,
  setCommonAreaAssetFormData,
} from "../../store/actions/commonAreaAssetForm";
import { selectSearch } from "../../store/selectors/search";
import { selectAuthenticatedUser } from "../../store/selectors/auth";
import { variables } from "../../Tenants";

class CommonAreaAssetsTable extends Component {
  state = {
    showOverlay: false,
    formData: {
      item_id: "",
      serial_number: "",
      room: "",
      dateOfPurchase: null,
    },
    initialFormData: {
      item_id: "",
      serial_number: "",
      room: "",
      dateOfPurchase: null,
    },
  };
  render() {
    const {
      user,
      commonArea,
      onSearch,
      search,
      commonAreaAssets,
      setCommonAreaAssetFormData,
      onSaveCommonAreaAsset,
      clearCommonAreaAssetFormData,
      onDeleteCommonAreaAsset,
    } = this.props;
    const { showOverlay, newAsset } = this.state;
    let homeOwnerCheck =
      user &&
      user.roles &&
      user.roles.length > 0 &&
      (user.roles[0].role.name === "Home Owner" ||
        user.roles[0].role.name === "Occupant")
        ? true
        : false;
    return (
      <>
        <Actions compact>
          <Search
            size="small"
            placeholder="Search Common Areas..."
            onChange={onSearch}
          />
          {homeOwnerCheck ? null : (
            <Button
              color="teal"
              label="Add Common Area Asset"
              onClick={() => {
                setCommonAreaAssetFormData({
                  assetWarrantyDefaultStartDate: null,
                  dateOfPurchase:
                    commonArea && commonArea.dateOfPurchase
                      ? commonArea.dateOfPurchase
                      : null,
                });
                this.setState({
                  showOverlay: true,
                  formData: this.state.initialFormData,
                  newAsset: true,
                });
              }}
              icon={<Icon glyph="home" weight="light" size="small" />}
              size="small"
            />
          )}
        </Actions>
        {commonAreaAssets.length > 0 ? (
          <>
            <Table
              columns={[
                {
                  label: "Item",
                  sortable: true,
                  accessor: "item.name",
                  cell: (data) => (
                    <Link>
                      {data.item.name}
                    </Link>
                  ),
                },
                {
                  label: "Make",
                  cell: (data) =>
                    data.item && data.item.makeName ? data.item.makeName : "—",
                },
                {
                  label: "Model",
                  cell: (data) =>
                    data.item && data.item.model ? data.item.model : "—",
                },
                {
                  xsHide: true,
                  label: "Warranty Expiration",
                  cell: (data) => {
                    const color =
                      data.warrantDays < 30
                        ? "red"
                        : data.warrantDays < 60
                        ? "yellow"
                        : "teal";
                    return (
                      <Label
                        color={color}
                        label={
                          data.item.warrantyYears === "0"
                            ? "----- NA -----"
                            : moment(data.warrantExpiration).format(
                                "MM/DD/YYYY"
                              )
                        }
                      />
                    );
                  },
                },
                {
                  cell: (data) =>
                    homeOwnerCheck ? null : (
                      <Hidden>
                        <Button
                          color="semantic"
                          label={<Icon glyph="pencil" weight="light" />}
                          onClick={() => {
                            setCommonAreaAssetFormData({
                              ...data,
                              dateOfPurchase: data.dateOfPurchase,
                            });
                            this.setState({
                              showOverlay: true,
                              newAsset: false,
                            });
                          }}
                        />
                        <Button
                          color="semantic"
                          onClick={(e) =>
                            window.confirm(
                              `Are you sure you want to delete ${data.item.name}?`
                            ) && onDeleteCommonAreaAsset(data.id)
                          }
                          label={<Icon glyph="trash" weight="light" />}
                        />
                      </Hidden>
                    ),
                },
              ]}
              data={commonAreaAssets}
            />
          </>
        ) : (
          <Empty
            headline="This common area is empty"
            strapline="Add assets to this common area and attach relevant documentation such as manuals and warranties."
            searchIsActive={
              search && search.commonArea ? search.commonArea : ""
            }
            cta={
              homeOwnerCheck ? null : (
                <Button
                  color="teal"
                  label="Add Common Area Asset"
                  onClick={() => {
                    setCommonAreaAssetFormData({
                      assetWarrantyDefaultStartDate: null,
                      dateOfPurchase:
                        commonArea && commonArea.dateOfPurchase
                          ? commonArea.dateOfPurchase
                          : null,
                    });
                    this.setState({
                      showOverlay: true,
                      formData: this.state.initialFormData,
                      newAsset: true,
                    });
                  }}
                  icon={<Icon glyph="boxes" weight="light" size="small" />}
                  size="small"
                />
              )
            }
            image={
              <img
                src="/assets/empty/assets.svg"
                alt={`This ${variables.suite} is empty`}
              />
            }
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <CommonAreaAssetForm
              newAsset={newAsset}
              commonAreaId={commonArea.id}
              onClose={() => {
                this.setState({ showOverlay: false }, () =>
                  clearCommonAreaAssetFormData()
                );
              }}
              onSaveCommonAreaAsset={onSaveCommonAreaAsset}
            />
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  search: selectSearch(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setCommonAreaAssetFormData,
      clearCommonAreaAssetFormData,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommonAreaAssetsTable);
